import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { Observable } from 'rxjs';
import { RecommendedJobEventRequest } from '../models/recommended-job-event-request';

@Injectable({
    providedIn: 'root'
})
export class RecommendJobEventsService {
    private coreApiPath = '';

    private httpClient = inject(HttpClient);
    private settings = inject(APP_CONFIG);

    constructor() {
        this.coreApiPath = combine(this.settings.coreAPIUrl, 'ayanova');
    }

    saveEvent(request: RecommendedJobEventRequest): Observable<void> {
        return this.httpClient.post<void>(`${this.coreApiPath}/recommended-job-events`, request);
    }
}
